import React from "react";

// App Bridge v4 renders a top navigation bar inside the embedded iframe
// from a <ui-nav-menu> custom element. The first <a> with rel="home" is
// the app's root; the rest are tabs. App Bridge intercepts clicks and
// updates the iframe URL — React Router picks up the change normally.
const EmbeddedNavMenu: React.FC = () => {
  return React.createElement(
    "ui-nav-menu",
    null,
    <a href="/" rel="home">
      Home
    </a>,
    <a href="/publishing">Publishing</a>
  );
};

export default EmbeddedNavMenu;
